/** Allowed controller statuses */
export const CONTROLLER_STATUS = {
    ONLINE: 'online',
    OFFLINE: 'offline',
};
